module.exports = __webpack_public_path__ + "static/media/tr.657ea685.svg";